import { render, staticRenderFns } from "./OrderInfoShipping.vue?vue&type=template&id=3ae5ed06&"
import script from "./OrderInfoShipping.vue?vue&type=script&lang=js&"
export * from "./OrderInfoShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports